import Vue from "vue";
import Vuetify from "vuetify";
// @ts-ignore
import pt from "vuetify/lib/locale/pt";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  lang: {
    locales: {
      "pt-BR": {
        ...pt,
        dataIterator: {
          rowsPerPageText: "Registros por página:",
          rowsPerPageAll: "Todos",
          pageText: "{0}-{1} de {2}",
          noResultsText: "Sem registros",
          nextPage: "Próxima",
          prevPage: "Anterior",
          loadingText: "Carregando",
        },
        dataTable: {
          itemsPerPageText: "Itens por página:",
          ariaLabel: {
            sortDescending: "Ordenado decrescente.",
            sortAscending: "Ordenado crescente.",
            sortNone: "Não ordenado.",
            activateNone: "Ativar para remover ordenação.",
            activateDescending: "Ativar para ordenar decrescentemente.",
            activateAscending: "Ativar para ordenar crescentemente.",
          },
          sortBy: "Ordenar por",
        },
        noDataText: "Sem registros",
      },
    },
    current: "pt-BR",
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#000000",
        secondary: "#f5c824",
        terciary: "#F6ECE8",
        accent: "#ACBFD7",
        error: "#F25F48",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107",
        google: "#4285F4",
        facebook: "#1877F2",
        menu: "#f5f5f5",
      },
    },
  },
});
